import React, { useContext } from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { NavHeaderStyles, NavLogoStyles, NavItemsStyles } from './styled'

import { AuthContext } from '../../context/auth-context'
import logo from '../../swiftlogo.png'

const Navigation = props => {
  const authContext = useContext(AuthContext)

  return (
    <NavHeaderStyles>
      <NavLogoStyles>
        <img src={logo} alt='swift-location-service' onClick={() => props.history.push('/vehicles')} />
      </NavLogoStyles>
      <NavItemsStyles>
        <ul>
          {!authContext.token &&
            <li>
              <NavLink to='/auth'>Authenticate</NavLink>
            </li>}
          {authContext.token &&
            <>
              <li>
                <NavLink to='/vehicles'>Vehicles</NavLink>
              </li>
              <li>
                <NavLink to='/branches'>Branches</NavLink>
              </li>
              <li>
                <NavLink to='/map'>Map</NavLink>
              </li>
              <li>
                <button onClick={authContext.handleLogout}>Logout</button>
              </li>
            </>}
        </ul>
      </NavItemsStyles>
    </NavHeaderStyles>
  )
}

export default withRouter(Navigation)

Navigation.propTypes = {
  history: PropTypes.object
}
